import Vue from 'vue';
import Vuex from 'vuex';
import { authenticationModule } from './modules/authenticationModule';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    authenticationModule
  }
});
